import React, { Fragment } from "react";
import { Outlet } from "react-router-dom";
import useModernAssets from "../../hooks/useModernAssets";
import Header from "../includes/Header";
import Footer from "../includes/Footer";
// Import your NEW Header/Footer designed for Bootstrap 5 here
// import HeaderModern from "../includes/HeaderModern"; 

const ModernLayout = ({ member }) => {
  useModernAssets(); 

  return (
    <div className="modern-v5-scope">
      {/* If you want the old header, uncomment below, 
         but be warned: BS5 CSS might distort it. 
      */}
      <Header access="public" member={member} />
      
      <main>
        <Outlet /> 
      </main>
        <Footer />
      {/* Suggestion: Add a simplified ModernFooter here */}
    </div>
  );
};

export default ModernLayout;